<template>
  <mb-panel
    v-if="uiloading"
    :title="
      !isAirplusModule
        ? $i18n.t('orderac.title.header')
        : $i18n.t('device.title.header')
    "
  >
    <mb-section>
      <p
        v-html="
          !isAirplusModule
            ? $i18n.t('orderac.title.description')
            : $i18n.t('device.title.description')
        "
      ></p>
      <p v-if="isAirplusModule" v-html="$i18n.t('device.text.description')"></p>
      <mb-field v-if="isAirplusModule">
        <mb-checkbox-group
          labelfor="costFlag"
          :label="$i18n.t('device.customer.person.cost.disclaimer.label')"
          :validator="$v.request.customer.person.costFlag"
          :message="message.request.customer.person.costFlag"
        >
          <mb-checkbox                         
            id="costFlag"
            required
            v-model="request.customer.person.costFlag"
          >
            <span
              v-html="$i18n.t('device.customer.person.cost.disclaimer.text')"
            />
          </mb-checkbox>
        </mb-checkbox-group>
      </mb-field>

      <mb-field>
        <mb-input
          labelfor="contractId"
          :label="$i18n.t('orderac.customer.label.contractid')"
          :info="$i18n.t('orderac.customer.label.contractid')"
          :infotext="$i18n.t('orderac.customer.popup.contractid.text')"
          id="contractId"
          v-model="request.customer.contractId"
          :validator="$v.request.customer.contractId"
          :message="message.request.customer.contractId"
        ></mb-input>
      </mb-field>

      <mb-field v-if="isAirplusModule">
        <mb-input
          labelfor="accountNo"
          :label="$i18n.t('device.customer.label.accountno')"
          :info="$i18n.t('device.customer.label.accountno')"
          :infotext="$i18n.t('device.customer.popup.accountno.text')"
          id="accountNo"
          v-model="request.customer.person.accountNo"
          :validator="$v.request.customer.person.accountNo"
          :message="message.request.customer.person.accountNo"
        ></mb-input>
      </mb-field>

      <mb-field>
        <mb-radio-button-group
          labelfor="gender"
          :label="$i18n.t('orderac.customer.label.gender')"
          :validator="$v.request.customer.person.gender"
          :message="message.request.customer.person.gender"
        >
          <mb-radio-button
            name="gender"
            native-value="1"
            v-model="request.customer.person.gender"
          >
            <span v-t="'application.gender.1'" />
          </mb-radio-button>
          <mb-radio-button
            name="gender"
            native-value="2"
            v-model="request.customer.person.gender"
          >
            <span v-t="'application.gender.2'" />
          </mb-radio-button>
        </mb-radio-button-group>
      </mb-field>

      <mb-field>
        <mb-input
          labelfor="name"
          :label="$i18n.t('orderac.customer.label.lastname')"
          id="name"
          v-model="request.customer.person.name"
          :validator="$v.request.customer.person.name"
          :message="message.request.customer.person.name"
        ></mb-input>
      </mb-field>

      <mb-field>
        <mb-input
          labelfor="firstName"
          :label="$i18n.t('orderac.customer.label.firstname')"
          id="firstName"
          v-model="request.customer.person.firstName"
          :validator="$v.request.customer.person.firstName"
          :message="message.request.customer.person.firstName"
        ></mb-input>
      </mb-field>

      <mb-field>
        <mb-input
          labelfor="firm"
          :label="$i18n.t('orderac.customer.label.firm')"
          id="firm"
          v-model="request.customer.person.firm"
          :validator="$v.request.customer.person.firm"
          :message="message.request.customer.person.firm"
        ></mb-input>
      </mb-field>

      <mb-field>
        <mb-input
          id="streetName"
          labelfor="streetName"
          :label="$i18n.t('orderac.customer.label.street')"
          @input="setStreet"
          maxlength="25"
          column="col-9"
          v-model="request.streetName"
          :validator="$v.request.streetName"
          :message="message.request.streetName"
        ></mb-input>
        <mb-input
          id="streetNumber"
          @input="setStreet"
          maxlength="6"
          column="col-3"
          v-model="request.streetNumber"
        ></mb-input>
      </mb-field>

      <mb-field>
        <mb-plzort
          labelfor="zipCodeCity"
          :label="$i18n.t('orderac.customer.label.city')"
          id="zipCodeCity"
          :validator="$v.request.customer.zipCodeCity"
          :message="message.request.customer.zipCodeCity"
          @selectedZipcodeCityObject="selectedObject = $event"
          v-model="request.customer.zipCodeCity"
          inputName="zipCodeCity"
        >
        </mb-plzort>
      </mb-field>

      <mb-field>
        <mb-input
          labelfor="birthDate"
          :label="$i18n.t('orderac.customer.label.birthday')"
          id="birthDate"
          type="date"
          v-model="request.customer.person.birthDay"
          :validator="$v.request.customer.person.birthDay"
          :placeholder="$i18n.t('orderac.placeholder.date')"
          :message="message.request.customer.person.birthDay"
        ></mb-input>
      </mb-field>

      <mb-field>
        <mb-input
          labelfor="email"
          :label="$i18n.t('orderac.customer.label.email')"
          id="email"
          v-model="request.customer.person.email"
          :validator="$v.request.customer.person.email"
          :message="message.request.customer.person.email"
        ></mb-input>
      </mb-field>

      <mb-field
        v-for="(question, index) in request.randomQuestionnaire"
        :key="question.key"
      >
        <mb-radio-button-group
          :label="$i18n.t(question.query)"
          info
          :infotext="$i18n.t('orderac.question.popup.text.' + question.id)"
          v-if="question.id == 1"
          :validator="$v.request.randomQuestionnaire.$each[index].selectedKey"
          :message="message.request.randomQuestionnaire.question"
        >
          <mb-radio-button
            native-value="O"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.1.O'" />
          </mb-radio-button>
          <mb-radio-button
            native-value="L"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.1.L'" />
          </mb-radio-button>
        </mb-radio-button-group>

        <mb-radio-button-group
          :label="$i18n.t(question.query)"
          info
          :infotext="$i18n.t('orderac.question.popup.text.' + question.id)"
          v-if="question.id == 2"
          :validator="$v.request.randomQuestionnaire.$each[index].selectedKey"
          :message="message.request.randomQuestionnaire.question"
        >
          <mb-radio-button
            native-value="N"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.2.N'" />
          </mb-radio-button>
          <mb-radio-button
            native-value="I"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.2.I'" />
          </mb-radio-button>
          <mb-radio-button
            native-value="A"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.2.A'" />
          </mb-radio-button>
        </mb-radio-button-group>

        <mb-radio-button-group
          :label="$i18n.t(question.query)"
          info
          :infotext="$i18n.t('orderac.question.popup.text.' + question.id)"
          v-if="question.id == 3"
          :validator="$v.request.randomQuestionnaire.$each[index].selectedKey"
          :message="message.request.randomQuestionnaire.question"
        >
          <mb-radio-button
            column="col"
            native-value="Y"
            @change="displayTextBox('Y', index)"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.default.Y'" />
          </mb-radio-button>
          <mb-radio-button
            column="col"
            native-value="N"
            @change="displayTextBox('N', index)"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.default.N'" />
          </mb-radio-button>
          <mb-input
            id="textBox"
            column="col"
            minlength="5"
            maxlength="5"
            v-if="enableTextBox"
            v-model="request.randomQuestionnaire[index].selectedValue"
            :validator="
              $v.request.randomQuestionnaire.$each[index].selectedValue
            "
            :message="message.request.randomQuestionnaire.question"
          ></mb-input>
        </mb-radio-button-group>

        <mb-radio-button-group
          :label="$i18n.t(question.query)"
          info
          :infotext="$i18n.t('orderac.question.popup.text.' + question.id)"
          v-if="question.id == 4 || question.id > 5"
          :validator="$v.request.randomQuestionnaire.$each[index].selectedKey"
          :message="message.request.randomQuestionnaire.question"
        >
          <mb-radio-button
            native-value="Y"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.default.Y'" />
          </mb-radio-button>
          <mb-radio-button
            native-value="N"
            v-model="request.randomQuestionnaire[index].selectedKey"
          >
            <span v-t="'orderac.answer.default.N'" />
          </mb-radio-button>
        </mb-radio-button-group>
      </mb-field>

      <div class="Form--buttons">
        <mb-button gradient @click.prevent="validateActivationRequest">{{
          $i18n.t("orderac.button.submit")
        }}</mb-button>
        <a
          @click.prevent="initialize"
          class="Button btn btn-link btn-link-primary"
          >{{ $i18n.t("orderac.button.cancel") }}</a
        >
      </div>
    </mb-section>
    <mb-loader backdrop v-if="loader"></mb-loader>
  </mb-panel>
</template>
<script>
import Service from "@/service/backend-api";
import formValidationRules from "./validation";
import { mapActions, mapState, mapGetters } from "vuex";
import PlzOrt from "@/components/plzort.vue";
import validatorMixins from "@/mixins/validators/validatorMixins";

export default {
  name: "activationRequest",
  mixins: [validatorMixins],
  computed: {
    ...mapState(["message"]),
    ...mapGetters(["isAirplusModule"]),
  },
  components: {
    mbPlzort: PlzOrt,
  },
  data() {
    return {
      request: null,
      response: null,
      uiloading: false,
      loader: false,
      selectedObject: {},
      enableTextBox: false,
    };
  },
  validations: formValidationRules,
  created() {
    this.initialize();
    this.LOAD_VALIDATION_MESSAGE();
    console.log("ActivationRequest Component Created : ");
  },
  watch: {
    selectedObject: {
      handler(newValue, oldValue) {
        console.dir(newValue);
        this.onChangeZipcodeCity(newValue);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["LOAD_VALIDATION_MESSAGE"]),
    initialize: function () {
      Service.activationRequest()
        .then(({ data }) => {
          this.request = data;
          this.uiloading = true;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    validateActivationRequest: function () {
      this.$v.$touch();
      if (this.$v.$error) {
        this.highlightFirstErrorIfExist();
        console.log("validation failed");
      } else {
        this.getActivationResponse();
      }
    },
    getActivationResponse: function () {
      this.loader = true;
      this.$store.commit("SET_FORM_SUBMITTED", true);
      Service.activationResponse(this.request)
        .then(({ data }) => {
          this.loader = false;
          this.response = data;
          console.log("RESPONSE : " + this.response);
          if (this.response === "ActivationResponse") {
            this.$router.push({ name: "ActivationResponse" });
          } else if (this.response === "ActivationError") {
            this.$router.push({ name: "ActivationError" });
          } else {
            this.$router.push({
              name: "ActivationCode",
              params: { activationCode: this.response },
            });
          }
          this.$store.commit("SET_FORM_SUBMITTED", false);
        })
        .catch((error) => {
          this.loader = false;
          this.validateServerErrorsIfExist(this.$v, error.response);
          this.$store.commit("SET_FORM_SUBMITTED", false);
        });
    },
    setStreet: function () {
      this.request.customer.street =
        this.request.streetName + "," + this.request.streetNumber;
    },
    onChangeZipcodeCity(selectedZipcodeCityDetails) {
      console.dir(selectedZipcodeCityDetails);
      this.request.customer.zipCodeCity = selectedZipcodeCityDetails.value;
      this.request.customer.zipCode = selectedZipcodeCityDetails.plz;
      this.request.customer.city = selectedZipcodeCityDetails.ort;
    },
    displayTextBox: function (value, index) {
      if (value && value == "N") {
        this.enableTextBox = false;
        this.request.randomQuestionnaire[index].selectedValue = "00000";
      } else if (value == "Y") {
        this.enableTextBox = true;
        if (this.request.randomQuestionnaire[index].selectedValue === "00000") {
          this.request.randomQuestionnaire[index].selectedValue = "";
        }
      }
    },
  },
};
</script>
